/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_DenyInputs */

const en_tx_status_deny = /** @type {(inputs: Tx_Status_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

const id_tx_status_deny = /** @type {(inputs: Tx_Status_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditolak`)
};

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Tx_Status_DenyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_deny = /** @type {((inputs?: Tx_Status_DenyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_DenyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_deny(inputs)
	return en_tx_status_deny(inputs)
});